import React, { useEffect, useRef, useState } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  GDSStyleObject,
  Divider,
  ParagraphText,
  StackLayout,
  Radio,
  Button,
} from '@leagueplatform/genesis-core';

import { getRefValue } from '../../../utils/index';
import { AccordionData, Preference } from '../../../types/accordian.types';

import * as constants from '../../../utils/constant';

import { COMMUNICATION_LIBRARY_ASSET_KEYS } from '../../../types/communication-library.types';

import './accordianItem.css';

function AccordionItem({
  data,
  isOpen,
  btnOnClick,
  handleChange,
  result,
}: {
  data: AccordionData;
  isOpen: boolean;
  btnOnClick: () => void;
  handleChange: (x: {}) => void;
  result: Preference;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (isOpen) {
      const contentEl = getRefValue(contentRef);

      // eslint-disable-next-line no-unsafe-optional-chaining
      setHeight(contentEl?.scrollHeight + 10);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <li
      data-testid="preferece-item"
      className={`accordion-item ${isOpen ? 'active' : ''}`}
    >
      <Divider aria-hidden={false} css={{ margin: '0px' }} />
      <ParagraphText
        onClick={btnOnClick}
        css={
          {
            paddingTop: '20px',
            paddingLeft: '$oneAndHalf',
            paddingRight: '$oneAndHalf',
            paddingBlockEnd: '20px !important',
            justifyContent: 'space-between',
            display: 'flex',
            marginBlockEnd: '0px !important',
            letterSpacing: '-0.2px',
            lineHeight: '20px',
            fontSize: '16px',
            cursor: 'pointer',
          } as GDSStyleObject
        }
      >
        {data.title}
        <Button
          onChange={btnOnClick}
          css={
            {
              backgroundColor: 'initial !important',
              padding: '0px',
              height: '26px',
              width: '26px',
              pointerEvents: 'all',
              '.GDS-c-PJLV': {
                height: '24px',
              },
            } as GDSStyleObject
          }
          tabIndex={0}
        >
          <div>
            <img
              src={
                useStaticAsset(
                  isOpen
                    ? COMMUNICATION_LIBRARY_ASSET_KEYS.UP_ICON
                    : COMMUNICATION_LIBRARY_ASSET_KEYS.DOWN_ICON,
                ) as string
              }
              alt="down icon"
            />
          </div>
        </Button>
      </ParagraphText>

      <div className="accordion-item-container" style={{ height }}>
        <div ref={contentRef} className="accordion-item-content">
          <ParagraphText
            css={
              {
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '21px',
                letterSpacing: '-0.154px',
                color: 'rgba(0, 0, 0, 0.80)',
                margin: '10px 24px',
              } as GDSStyleObject
            }
          >
            {data.description}
          </ParagraphText>

          <StackLayout
            css={{ textAlign: 'left', padding: '10px 24px 10px 24px' }}
            horizontalAlignment="stretch"
          >
            {data.options &&
              data.options.map((item) => (
                <ParagraphText
                  key={`${data.title}-${item.label}`}
                  css={
                    {
                      marginBlockEnd: '25px !important',
                      justifyContent: 'space-between',
                    } as GDSStyleObject
                  }
                >
                  <Radio
                    data-testid="radio-indicator"
                    layout="row"
                    name={data.title}
                    className="preference-radio"
                    label={item.label}
                    tabIndex={height > 0 ? 0 : -1}
                    checked={
                      result[
                        constants.getPreferenceNameKey(
                          data.title,
                        ) as keyof Preference
                      ] === item.label
                    }
                    value={item.label}
                    css={
                      {
                        '.GDS-radio': {
                          pointerEvents: 'all',
                        },
                        '.GDS-radio-label': {
                          color: 'rgba(0, 0, 0, 0.80)',
                          fontSize: 14,
                          fontStyle: 'normal',
                          fontWeight: 500,
                          lineHeight: '21px',
                          letterSpacing: '-0.154px',
                        },
                        '.GDS-radio-label-hint': {
                          padding: '5px',
                          margin: '-5px',
                          pointerEvents: 'none',
                        },
                      } as GDSStyleObject
                    }
                    onChange={(e) => handleChange(e)}
                    onKeyPress={(e: any) => {
                      if (e.key === 'Enter') {
                        handleChange(e);
                      }
                    }}
                    id={constants.getPreferenceNameKey(data.title)}
                  />
                </ParagraphText>
              ))}
          </StackLayout>
        </div>
      </div>
    </li>
  );
}

export default AccordionItem;
